import doc                  from 'decorators/doc';
import SalesPrivateApiModel from 'modelx/models/abstracts/SalesPrivateApiModel';

@doc.path('/quotation_summaries/{?id}/calculate_projected')
export default class QuotationSummaryCalculateProjectedModel extends SalesPrivateApiModel {}